<div class="page-container mx-auto" [style.max-width]="'70vw'">
    <p class="st-title pt-6">{{ title }}</p>

    <div class="h-full flex flex-col py-4 overflow-hidden gap-6">
        <p-fieldset legend="Welcome to SesammTool 3">
            <div>
                "Sesamm Tool enables modelling and visualization of SESAMM. The application offers
                interactive network visualization, technical documentation features, and various
                report generation for SESAMM analysis. Designed for SESAMM engineers and system
                specialists working with SESAMM data."
            </div>
            <div class="pt-2 font-light">// Text generated by AI</div>
        </p-fieldset>

        <div class="flex flex-wrap gap-6 whitespace-nowrap">
            <p-fieldset legend="Dev Team" class="flex-1" styleClass="h-full">
                <dl>
                    <dt class="my-2">👤 Erik Comstedt</dt>
                    <dt class="my-2">🎮 Nuno Diogo</dt>
                    <dt class="my-2">💻 Jonathan Koitsalu</dt>
                    <dt class="my-2">😻 Nicole Polis</dt>
                    <dt class="my-2">🦀 Christine Qiu</dt>
                    <dt class="my-2">🦊 Lucas Reis</dt>
                </dl>
            </p-fieldset>
            <div class="flex flex-col flex-2 gap-6">
                <p-fieldset legend="Application Info">
                    <dl class="flex-1 gap-2 flex flex-col">
                        <dt><span class="font-semibold mr-2">Build:</span>{{ buildMode }}</dt>
                        <dt>
                            <span class="font-semibold mr-2">Web Version:</span> {{ webVersion }}
                        </dt>
                        <dt>
                            <span class="font-semibold mr-2">API Version:</span> {{ apiVersion }}
                        </dt>
                        <dt>
                            <i class="pi pi-external-link mr-2"></i>
                            Web Docs
                        </dt>
                        <dt>
                            <i class="pi pi-external-link mr-2"></i>
                            API Docs
                        </dt>
                    </dl>
                </p-fieldset>
                <p-fieldset legend="Contact & Support">
                    <i class="pi pi-comments mr-2" style="color: var(--primary-color)"></i>
                    <a
                        class="footer-link no-underline text-primary"
                        href="https://teams.microsoft.com/l/channel/19%3A0b7674988f2a41d09e4a34bd94f3b5ec%40thread.skype/Support%20and%20Feedback?groupId=b20c0fb0-2b11-4f41-a78a-c60fa8d141af&tenantId=3bc062e4-ac9d-4c17-b4dd-3aad637ff1ac"
                        target="_blank"
                        rel="noopener noreferrer"
                        >Support Teams Channel</a
                    >
                </p-fieldset>
            </div>
        </div>
    </div>
</div>
